import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useLoginByTemporalToken } from '@/features/auth';

const TEMPORAL_TOKEN_QUERY_PARAMETER = 'temporalToken';

export function useAuthByTemporalToken() {
  const [queryParams] = useSearchParams();
  const { mutate: loginByTemporalToken } = useLoginByTemporalToken();

  useEffect(() => {
    const temporalToken = queryParams.get(TEMPORAL_TOKEN_QUERY_PARAMETER);

    if (temporalToken) {
      loginByTemporalToken(temporalToken);
      queryParams.delete(TEMPORAL_TOKEN_QUERY_PARAMETER);
    }
  }, [queryParams]);
}
